















import { Vue, Component, Prop, Emit } from 'vue-property-decorator';

@Component
export default class AxCardSearch extends Vue {
  @Prop({ type: String })
  color!: string;

  @Emit()
  input() {
    return;
  }
}
